import {PerformanceOverviewLabel} from 'utils/constant';

import {
  getPerformance,
  getPerformanceOverview,
  getProductScoreTrends,
  getRequireUrgentAction,
  getTotalScoreTrend
} from './thunk';

export const vendorScoreBuilder = (builder: any) => {
  builder
    .addCase(getTotalScoreTrend.pending, (state: any) => {
      state.loading += 1;
      state.error = undefined;
    })
    .addCase(getTotalScoreTrend.fulfilled, (state: any, action: any) => {
      let temp: any[] = [];
      if (action.payload?.data?.scores.length >= 20) {
        action.payload.data.scores.map((item: any, index: any) => {
          if (index % 2 === 0) {
            temp.push(item);
          }
        });
      } else {
        temp = action.payload.data.scores;
      }

      state.totalScoreTrend = {...action.payload.data, scores: temp};
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getTotalScoreTrend.rejected, (state: any, action: any) => {
      state.error = action.payload.message;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getRequireUrgentAction.pending, (state: any) => {
      state.loading += 1;
      state.error = undefined;
    })
    .addCase(getRequireUrgentAction.fulfilled, (state: any, action: any) => {
      state.requireUrgentAction = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getRequireUrgentAction.rejected, (state: any, action: any) => {
      state.error = action.payload.message;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getPerformance.pending, (state: any) => {
      state.loading += 1;
      state.error = undefined;
    })
    .addCase(getPerformance.fulfilled, (state: any, action: any) => {
      state.performance = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getPerformance.rejected, (state: any, action: any) => {
      state.error = action.payload.message;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getProductScoreTrends.pending, (state: any) => {
      state.loading += 1;
      state.error = undefined;
    })
    .addCase(getProductScoreTrends.fulfilled, (state: any, action: any) => {
      state.productScoreTrends = action.payload.data;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getProductScoreTrends.rejected, (state: any, action: any) => {
      state.error = action.payload.message;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });

  builder
    .addCase(getPerformanceOverview.pending, (state: any) => {
      state.loading += 1;
      state.error = undefined;
    })
    .addCase(getPerformanceOverview.fulfilled, (state: any, action: any) => {
      if (action.payload.data) {
        const keys = Object.keys(action.payload?.data).map((label) => {
          return PerformanceOverviewLabel[label as keyof typeof PerformanceOverviewLabel];
        });
        const values = Object.values(action.payload?.data);
        state.performanceOverview = {labels: keys, data: values};
      }
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getPerformanceOverview.rejected, (state: any, action: any) => {
      state.error = action.payload.message;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
